/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const AdvancedOptions = defineMessages({
  title: {
    id: 'Facebook.AdvancedOptions.title',
    defaultMessage: 'Advanced options'
  },
  subtitle: {
    id: 'Facebook.AdvancedOptions.subtitle',
    defaultMessage:
      "Need help? <link>Learn more</link> about SMS's advanced options."
  }
});
